import React from 'react';
import { View, Text } from 'react-native';
import { startCase } from 'lodash';
import DocketItemStyles from '../DocketItem.styles';
import {
  DocketDisplayItemType,
  DisplayPreference,
} from '../../../common/types';
import theme from '../../../common/theme';
import { GroupDisplayStyle } from '@oolio-group/domain';
import Svg, { Line } from 'react-native-svg';

export interface DocketItemBaseProps {
  name: string;
  primaryGrouping?: boolean;
  displayPreference?: DisplayPreference;
}

const DocketItemHeader: React.FC<DocketItemBaseProps> = ({
  name,
  primaryGrouping,
  displayPreference,
}) => {
  const styles = DocketItemStyles();

  // If the display style is HIDDEN, don't render anything
  if (displayPreference?.displayStyle === GroupDisplayStyle.HIDDEN) {
    return null;
  }

  // If the display style is SEPARATOR, render only a line separator
  if (displayPreference?.displayStyle === GroupDisplayStyle.SEPARATOR) {
    return (
      <View testID="docket-separator" style={styles.separatorContainer}>
        <Svg height="4" width="100%">
          <Line
            x1="0"
            y1="0"
            x2="100%"
            y2="0"
            stroke={theme.colors.grey6}
            strokeWidth="2"
            strokeDasharray="4, 4"
          />
        </Svg>
      </View>
    );
  }

  // For HEADING style, show the full header with name
  return (
    <View
      testID="docket-course"
      style={[
        styles.statusContainer,
        !primaryGrouping
          ? styles.secondaryCourseContainer
          : styles.courseContainer,
      ]}
    >
      <Text
        style={
          !primaryGrouping
            ? styles.seatNumber
            : [styles.statusText, styles.courseText]
        }
      >
        {name ? startCase(name.toLowerCase()) : ''}
      </Text>
    </View>
  );
};

export default React.memo(DocketItemHeader);
